export default "__VITE_ASSET__bd0fcf98__"